export enum EnumFiltroContasBancarias {
    Banco = 'nomeBanco',
    Agencia = 'agencia',
}